import { styled } from '@mui/material/styles';
import { DatePicker as MuiDatepicker } from '@mui/x-date-pickers/DatePicker';

export const DatePicker = styled(MuiDatepicker)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        background: theme.palette.dashboard.main,
        borderRadius: 8,
        fontSize: 14,
        '& fieldset': {
            borderWidth: 1,
        },
        '&:hover fieldset': {
            borderWidth: 1,
        },
        '&.Mui-focused fieldset': {
            borderWidth: 1,
        },
    },
}));
